import React from "react";
import ProgressInner from "./ProgressInner";

function ProgressBox() {
  return (
    <div className="container">
      <div className="tokyo_tm_progressbox">
        <div className="container">
          <div className="in">
            <div className="left">
              <div className="tokyo_section_title">
                <h3>Programming Skills</h3>
              </div>
              <div className="tokyo_progress">
                <ProgressInner title="Python Flask" value="95" />
                <ProgressInner title="JavaScript" value="80" />
                <ProgressInner title="PHP Laravel" value="95" />
                <ProgressInner title="PHP CodeIgniter" value="95" />
                <ProgressInner title="React JS" value="90" />
              </div>
            </div>
            <div className="right">
              <div className="tokyo_section_title">
                <h3>Language Skills</h3>
              </div>
              <div className="tokyo_progress">
                <ProgressInner title="Indonesian" value="95" />
                <ProgressInner title="English" value="85" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProgressBox;
